import { REGEX_CODFIS } from "../../../../lib/utils/codice-fiscale";
import { Component, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { EvCaptchaComponent } from '../../../../lib/components/captcha/captcha.component';
import { EvForm } from '../../../../lib/models/ev-form.class';
import { HttpRequestResponse } from '../../../../lib/models/http-request-response.model';
import { HttpRequestService } from '../../../../lib/services/http-request.service';
import { ClassForScreenDirective } from '../../../../lib/directives/class-for-screen.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';


@Component({
    selector: 'app-forgot-pin',
    templateUrl: './forgot-pin.component.html',
    styleUrls: ['./forgot-pin.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ClassForScreenDirective, ReactiveFormsModule, FormsModule, EvCaptchaComponent, RouterLink]
})
export class ForgotPinComponent extends EvForm {
  private httpRequestService = inject(HttpRequestService);


  @ViewChild(EvCaptchaComponent) captcha: EvCaptchaComponent
  codiceFiscale: string;
  errorMessage: string;
  successMessage: string;

  get valid() {
    if (this.codiceFiscale && this.captcha) {
      return REGEX_CODFIS.test(this.codiceFiscale.toUpperCase()) && this.captcha.valid
    } else {
      return false
    }
  }

  onSubmitForgotPin() {
    this.httpRequestService
      .post('/recupera-username', {
        codiceFiscale: this.codiceFiscale.toUpperCase(),
      })
      .subscribe((response) => {
        if (HttpRequestResponse.isSuccessResponse(response)) {
          this.errorMessage = null;
          this.successMessage = response.message;
        } else {
          this.errorMessage = response.message;
          this.successMessage = null;
        }
      });
  }
}
